import PropTypes from "prop-types"
import React from "react"

class LoadingView extends React.Component {
  loadingText() {
    if (this.props.name) {
      return `Loading ${this.props.name}...`
    } else {
      return "Loading..."
    }
  }

  render() {
    if (this.props.errorMessage) {
      return (
        <div className="bs-p-5 text-muted text-center">
          {this.props.errorMessage}
        </div>
      )
    } else {
      return (
        <div className="bs-p-5 text-muted text-center">
          <h3 className="bs-mb-5">{this.loadingText()}</h3>
          <i className="icon icon-spinner icon-spin h1" />
        </div>
      )
    }
  }
}

LoadingView.propTypes = {
  name: PropTypes.string,
  errorMessage: PropTypes.string,
}

export default LoadingView
